import ownerSettlementsService from "@/services/ownerSettlementsService";

const state = () => ({
  all: [],
  single: null
});

const actions = {
  async create({ dispatch }, formData) {
    try {
      await ownerSettlementsService.create(formData);
      dispatch(
        "common/showSuccess",
        "Abrechnung wurde erfolgreich gespeichert.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Abrechnung konnte nicht gespeichert werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async findAll({ commit, dispatch }) {
    try {
      const res = await ownerSettlementsService.findAll();
      commit("setAll", res.data);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Abrechnungen für diesen Eigentümer konnten nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async getAttachementPdf({ dispatch }, formData) {
    try {
      const res = await ownerSettlementsService.getAttachementPdf(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Abrechnungs-PDF für diesen Eigentümer konnte nicht geladen werden." + error,
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async PDFPreview({ dispatch }, formData) {
    try {
      const res = await ownerSettlementsService.PDFPreview(formData);
      return Promise.resolve(res.data);
    } catch (error) {
      dispatch(
        "common/showError",
        "Abrechnungsvorschau konnte nicht geladen werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
  async delete({ dispatch }, { id }) {
    try {
      await ownerSettlementsService.delete({ id });
      dispatch(
        "common/showSuccess",
        "Abrechnung wurde erfolgreich gelöscht.",
        { root: true }
      );
      return Promise.resolve();
    } catch (error) {
      dispatch(
        "common/showError",
        "Abrechnung für diese Buchung konnte nicht gelöscht werden.",
        {
          root: true
        }
      );
      return Promise.reject();
    }
  },
};

const getters = {
};

const mutations = {
  setAll(state, object) {
    state.all = object;
  },
  setSingle(state, object) {
    state.single = object;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
